import script from "./TitleBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleBar.vue?vue&type=script&setup=true&lang=js"

import "./TitleBar.vue?vue&type=style&index=0&id=066ac87d&lang=css"

const __exports__ = script;

export default __exports__